import * as React from "react";
import * as styles from "./PhotosGallery.module.scss";
import { Row, Col } from "react-bootstrap";
import SubTitle from "../../global/SubTitle/SubTitle";
import { desktopOnly, mobileOnly } from "../../../styles/global.module.scss";
import BackgroundImage from "gatsby-background-image";
import { convertToBgImage } from "gbimage-bridge";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Img from "gatsby-image";
import { buildFluidImageData } from "@imgix/gatsby";

export const Container = (props: { children: any }): JSX.Element => {
  return (
    <div className={styles.container} id="photo-gallery">
      {props.children}
    </div>
  );
};

export const Thumbnail = (props: {
  fluid: any;
  image: {
    gatsbyImage: any;
    url?: string;
    alt?: string;
    fluid?: any;
  };
}): JSX.Element => {
  const fluid = props.fluid ? getImage(props.fluid) : null;
  const bgImage = fluid ? convertToBgImage(fluid) : null;
  const image = props.image?.gatsbyImage
    ? getImage(props.image?.gatsbyImage as any)
    : null;

  return bgImage ? (
    <BackgroundImage
      {...bgImage}
      preserveStackingContext
      className={`pt-4 pb-4 pt-md-5 pb-md-5 position-relative`}
    ></BackgroundImage>
  ) : image ? (
    <GatsbyImage
      className={styles.thumbnail}
      image={image}
      alt={props.image.alt}
    />
  ) : (
    <Img
      className={styles.thumbnail}
      fluid={buildFluidImageData(
        props.image.url,
        {
          ar: 1.18,
          auto: ["format", "compress"],
        },
        {
          sizes: "100%",
        }
      )}
      alt={props.image.alt}
    />
  );
};

export const FirstRow = (props: {
  gallery: any;
  imgCountPerRow: number;
  onThumbnailClick: React.MouseEventHandler<HTMLDivElement>;
  title: string;
  subtitle: string;
  color: string;
}): JSX.Element => {
  const { gallery, imgCountPerRow, onThumbnailClick } = props;
  const firstRowImages = [];
  const colSpan = 8 / parseInt(imgCountPerRow);
  for (let idx = 0; idx < imgCountPerRow; idx++) {
    firstRowImages.push(
      <Col
        className={`${idx > 0 ? desktopOnly : ""}`}
        key={`row1-image-${idx}`}
        md={colSpan}
        sm={"12"}
      >
        <div
          className={styles.photoContainer}
          id={`gallery-image-row1-${idx}`}
          onClick={onThumbnailClick}
          data-number={idx}
        >
          <Thumbnail image={gallery[idx]} />
          <div className={`${styles.photosMore} ${mobileOnly}`}>
            <svg className="icon">
              <use xlinkHref="/svg/gallery-icon.svg#gallery-icon"></use>
            </svg>
            <span>+{gallery.length - 1}</span>
          </div>
        </div>
      </Col>
    );
  }

  return (
    <Row className={`${styles.row1}`}>
      {firstRowImages}
      <Col md={"4"} sm={"12"}>
        <div className={`${styles.content}`}>
          {props.subtitle && (
            <SubTitle>
              <span
                style={{ cursor: "pointer" }}
                onClick={onThumbnailClick}
                data-number={0}
                id="take-visual-tour-button"
              >
                {props.subtitle}
              </span>
            </SubTitle>
          )}
          <h2 id="photo-gallery">{props.title || "Photo Gallery"}</h2>
        </div>
      </Col>
    </Row>
  );
};

export const SecondRow = (props: {
  gallery: any;
  imgCountPerRow: number;
  onThumbnailClick: React.MouseEventHandler<HTMLDivElement>;
}): JSX.Element => {
  const { gallery, imgCountPerRow, onThumbnailClick } = props;
  const secondRowImages = [];
  for (let idx = imgCountPerRow; idx < gallery.length; idx++) {
    secondRowImages.push(
      <Col className={`col-4`} key={`row2-image-${idx}`}>
        <div
          className={`${styles.photoContainer} second-row`}
          id={`gallery-image-row2-${idx}`}
          onClick={onThumbnailClick}
          data-number={idx}
        >
          <Thumbnail image={gallery[idx]} />
          {idx == imgCountPerRow + 2 && (
            <div
              className={`${styles.photosMore}`}
              onClick={onThumbnailClick}
              data-number={0}
            >
              <svg className="icon">
                <use xlinkHref="/svg/gallery-icon.svg#gallery-icon"></use>
              </svg>
              <span>+{gallery.length - 4}</span>
            </div>
          )}
        </div>
      </Col>
    );

    if (idx >= imgCountPerRow + 2) break;
  }

  return <Row className={`${styles.row2}`}>{secondRowImages}</Row>;
};
